import OfficeEditorColumnDropdown from './OfficeEditorColumnDropdown';

export default OfficeEditorColumnDropdown;